import { HeaderBackground } from "assets/images";
import { LinkButton } from "components/widgets";
import { SIGNUP } from "routes/CONSTANTS";

const GetInvolvedHero = () => {
  return (
    <>
      <header
        className="h-[68vh] bg-center bg-fixed bg-no-repeat bg-cover flex align-center justify-center w-full "
        style={{ backgroundImage: `url(${HeaderBackground})` }}
      >
        <div className="flex flex-col gap-8 justify-center items-center px-6 sm:px-8 md:px-12 lg:px-56 ">
          <div className="text-white font-bold md:font-semibold text-3xl md:text-6xl text-center md:leading-tight">
            Break stigma, promote wellness together
          </div>
          <div className="pt-2 md:pt-8">
            <LinkButton to={SIGNUP}>Get Involved</LinkButton>
          </div>
        </div>
      </header>
    </>
  );
};

export default GetInvolvedHero;
